<template>
  <div v-if="items && items.length > 0" class='fct-input-control chip-select'>
    <label class="label" v-if="label" v-html="label"></label>
    <br>
    <v-bar class="scroll-area" :settings="{suppressScrollX: true, useBothWheelAxes: true}">
      <div class="container" style="max-height: 300px;">
        <button v-for="(item, index) in items" v-if="index < limit" :class="['fct-chip', {check: item === value}]"
                v-text="field ? item[field] : item"
                @click="onItemClick(item)"></button>
        <p></p>
      </div>
    </v-bar>
    <div class="actions">
      <button :disabled="initialValue === value" class="fct-button default" @click="onConfirm()">Confirm</button>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['value', 'items', 'label', 'field', 'limit', 'rowsAmount', 'colsAmount'],
    data() {
      return {
        initialValue: this.value,
      }
    },
    methods: {
      onItemClick(value) {
        this.$emit('input', value)
      },
      onConfirm() {
        this.$emit('confirm')
      },
      getItemIndex(rowIndex, colIndex) {
        return (colIndex * this.rowsAmount) + rowIndex
      }
    },
    computed: {
      colsTotal() {
        return Math.ceil((this.items).length / this.rowsAmount)
      }
    }
  }
</script>

<style lang="scss">
  @import "../../sass/fct/variables";
  @import "../../node_modules/bulma/sass/utilities/mixins";

  .chip-select {
    margin: 10px 0;

    .label {
      line-height: 24px !important;
    }

    .fct-chip {
      /*background-color: #fff;*/
      margin: 10px 6px;
      box-shadow: 3px 2px 12px #efefef;
      &:hover {
        box-shadow: 3px 2px 12px #efefef;
      }

      &.check {
        color: #fff;
        background-color: $active-color;
      }
    }

    .scroll-area {
      position: relative;
      margin: auto;
      width: 100%;

      .ps__scrollbar-x-rail {
        display: none !important;
      }
    }
  }
</style>

<style scoped lang="scss">
  @import '../../node_modules/bulma/sass/utilities/mixins';

  .chip-select {
    @include mobile() {
      margin-bottom: 30px;
    }
  }



  br  {
    height: 4px;
  }

  .actions {
    text-align: center;

    margin-top: 30px !important;

    @include mobile() {
      margin-top: 40px;
    }
  }
</style>
